import { getBaseRole } from '@/helpers/customRoles';
import s from './ChatMessage.module.css'
import {ClipIcon, DeleteChatIcon, DotsIcon} from "@/utils/icons";
import Moment from 'react-moment';
import moment from "moment";
import 'moment/locale/ru';
import UserImage from "@common/Chat/components/UserImage/UserImage";
import React, {useRef, useState} from "react";
import classNames from "classnames";
import { Emoji, EmojiStyle } from 'emoji-picker-react';
import {chatApi, telegramBotIntegrationApi} from "@/api";
import {getAvatar} from "@common/Chat/helpers";
import {Image, Tooltip} from "antd";
import JsonPars from '@UI/JsonPars/JsonPars'
import { normalizeTiptapContent } from '@/helpers/tiptapContent'
import {useSelector} from "react-redux";
import {selectProfile} from "@store/profile.reducer";
import {useAddAlert} from "@/hooks/useAddAlert";
import roleActive from '@/helpers/roleActive'
import {getMessageText} from '@/helpers/messageText';
import {containsHtmlTags} from '@/utils/RegexUtils/regexMatch';
import useIsTechSupport from '@common/Chat/SupportChatButton/useIsTechSupport';
import { roleAdminInChat, rolesChatParticipants } from '@common/Chat/constants';
import { FileView } from '../FileView/FileView';
import { mentionMarkupRegex } from '@common/Chat/helpers/mentions';
import useOpenPrivateChatFromGroupChat from '@/hooks/useOpenPrivateChatFromGroupChat';
import OpenPrivateChatButton from '../OpenPrivateChatButton';
import { ShareAltOutlined, UserOutlined } from '@ant-design/icons';
import { getParentChildrenInfo } from '@common/Chat/helpers/parentChildren';

moment.locale('ru')

const CHAT_REACTIONS = [
    { code: 'like', unified: '1f44d' },
    { code: 'thumbs_down', unified: '1f44e' },
    { code: 'heart', unified: '2764-fe0f' },
    { code: 'fire', unified: '1f525' },
    { code: 'thumbs_up', unified: '1f44c' },
    { code: 'laugh', unified: '1f602' },
    { code: 'wow', unified: '1f62e' },
    { code: 'sad', unified: '1f622' },
]

const reactionCodeToUnified = CHAT_REACTIONS.reduce((acc, item) => {
    acc[item.code] = item.unified
    return acc
}, {})

const getMessagePreview = (message) => {
    const rawMessage = message?.message;
    const text = typeof rawMessage === 'string'
        ? rawMessage.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        : '';

    if (text) return text;

    const firstFile = Array.isArray(message?.files) ? message.files[0] : null;
    const fileType = String(firstFile?.type || firstFile?.mime_type || '');

    if (fileType.includes('audio')) return 'Голосовое сообщение';
    if (fileType.includes('image')) return 'Изображение';
    if (firstFile) return firstFile?.original || firstFile?.name || 'Файл';

    return 'Сообщение';
}

const ParentChildrenIcon = ({ member, visible }) => {
    const { isParent, hasChildrenData, childrenNames } = getParentChildrenInfo(member);

    if (!visible || !isParent || !hasChildrenData) return null;

    const tooltip = childrenNames.length
        ? `Учащиеся: ${childrenNames.join(', ')}`
        : 'Учащиеся не привязаны';

    return (
        <Tooltip title={tooltip} mouseEnterDelay={0}>
            <span
                className={s.parentChildrenIcon}
                aria-label={tooltip}
                onClick={(event) => event.stopPropagation()}
            >
                <UserOutlined />
            </span>
        </Tooltip>
    );
}

const ChatMessage = ({
     message,
     data,
     setAnswer,
     setAnswerAuthor,
     setIsNeedUpdate,
     activeUsers,
     setPage,
     onDeleteMessage = new Function(),
     onToggleReaction = new Function(),
     onPinMessage = null,
     localActions = false,
     hideActionsMenu = false,
     isOwnMessageOverride = null,
     onForwardMessage = null,
     onEditMessage = null,
}) => {
    const { adminActive } = roleActive()
    const addAlert = useAddAlert()
    const profile = useSelector(selectProfile);
    const isUsersCannotDeleteMessagesInChatsStore = useSelector(
        (store) => store.settings.isUsersCannotDeleteMessagesInChats
    );
    const showParentChildren = useSelector(
        (store) => store.settings.isShowParentChildrenInChat === '1'
    );
    const member = data?.members?.find(el => el?.user_id === profile.id)
    const myRole = member?.role
    const isChatAdmin = rolesChatParticipants[myRole] === roleAdminInChat;
    const [isActive, setIsActive] = useState(false)
    const [isReactionPickerOpen, setIsReactionPickerOpen] = useState(false)
    const [isReactionLoading, setIsReactionLoading] = useState(false)
    const openMenu = (e) => {
        e.stopPropagation()
        setIsActive(!isActive)
    }

    const parentMessage = message?.parentId ? data?.messages.find(el => el.id === message?.parentId) : null
    const parentMessageAuthor = parentMessage ? data?.members.find(el => el?.member_id === parentMessage?.author) : null
    const menuRef = useRef(null)
    moment.locale('ru' )
    const authorName = data?.members?.find(member => message?.author == member?.member_id)
    const isUserOnline = activeUsers.filter(id => id == authorName?.user_id);
    const authorDisplayName = authorName?.name || 'Неизвестный пользователь';
    const { canOpenPrivateChat, openPrivateChat } = useOpenPrivateChatFromGroupChat({
        isGroupChat: data?.type === 'group',
        targetUserId: authorName?.user_id,
        setPage,
    });
    // Админ чата удаляет любые сообщения независимо от запрета в настройках
    const canDeleteMessage =
        adminActive() ||
        isChatAdmin ||
        (
            isUsersCannotDeleteMessagesInChatsStore !== '1' &&
            member?.member_id === message.author
        );
    const isFixedMessage = Array.isArray(data?.fixedMessages) &&
        data.fixedMessages.some((fixedMessage) => String(fixedMessage?.id) === String(message?.id));
    const fixMessageMenuText = isFixedMessage
        ? 'Открепить сообщение'
        : 'Закрепить сообщение в чате';
    const reactions = Array.isArray(message?.reactions) ? message.reactions : []
    const handleClick = (event) => {
        if (event?.target?.closest?.('a')) {
            return;
        }

        const selectedText = window.getSelection?.()?.toString?.().trim();

        if (selectedText) {
            return;
        }

        setAnswer(message)
        setAnswerAuthor(authorName)
    }

    const handleClip = (e) => {
        e.stopPropagation()
        setIsActive(false)

        if (localActions) {
            onPinMessage?.(message)
            return
        }

        chatApi.fixMessage(message.id).then((res) => setIsNeedUpdate(true))
        const request = isFixedMessage
            ? chatApi.unFixMessage(message.id)
            : chatApi.fixMessage(message.id)

        request.then((res) => setIsNeedUpdate(true))
    }

    const handleRemoveMessage = (e) => {
        e.stopPropagation()
        setIsActive(false)
        onDeleteMessage(message)

        if (localActions) return

        chatApi
            .removeMessage(message.id)
            .then(({response}) => {
                if (response?.data?.status === 'error') {
                    addAlert({type: 'error', title: response?.data?.error})
                }
            })
    }

    const additionalNotice = (e) => {
        e.stopPropagation()
    }

    const sendByTelegram = (e) => {
        e.stopPropagation()
        setIsActive(false)
        telegramBotIntegrationApi.chatMessage({
            messageId: message.id,
        }) 
        .then(({data}) => {
            if(data.status==='success'){
                addAlert({title: 'Успешно', text: 'Сообщение продублировано'})
            }
        })
    }
    const handleForwardMessage = (e) => {
        e.stopPropagation()
        setIsActive(false)
        onForwardMessage?.(message)
    }
    const { isTechSupport } = useIsTechSupport()

    const handleToggleReaction = async (reactionCode, event) => {
        event?.stopPropagation?.()

        if (!reactionCode || isReactionLoading) return

        setIsReactionLoading(true)
        try {
            await onToggleReaction(message?.id, reactionCode, reactions)
            setIsReactionPickerOpen(false)
        } finally {
            setIsReactionLoading(false)
        }
    }
    const canEditMessage = onEditMessage && Number(message?.id) > 0 && (
        message?.user_id != null
            ? Number(message.user_id) === Number(profile.id)
            : Number(message?.author) === Number(member?.member_id)
    );
    const editMessage = (event) => {
        event.stopPropagation();
        setIsActive(false);
        onEditMessage(message);
    };
    const editMenuItem = canEditMessage && (
        <button type='button' className={s.menuRow} onClick={editMessage}>
            <span className={s.menuName}>Редактировать</span>
        </button>
    );
    const isMyMessage = member?.member_id === message.author
    const isOwnMessage = typeof isOwnMessageOverride === 'boolean' ? isOwnMessageOverride : isMyMessage

    return (
        <div className={classNames(s.message,  isOwnMessage ? s.myMessage : '')} onClick={handleClick}>
            <div className={s.messageWr}>
                {
                    !isOwnMessage && <AvatarWithStatus {...{authorName, isUserOnline}} />
                }
                {!hideActionsMenu && isOwnMessage && <>
                    <div className={s.dots} onClick={(e) => openMenu(e)}><DotsIcon/></div>
                    <div className={classNames(s.menu, isActive ? s.active : '', s.menuLeft)} ref={menuRef}
                         onMouseLeave={() => setIsActive(false)}>
                        <div className={s.menuRow} onClick={handleClip}>
                            <div className={s.menuIcon}><ClipIcon width={'16'} height={'16'}/></div>
                            <div className={s.menuName}>{fixMessageMenuText}</div>
                        </div>
                        {editMenuItem}
                        {canDeleteMessage &&
                          <div className={s.menuRow} onClick={handleRemoveMessage}>
                              <div className={s.menuIcon}><DeleteChatIcon width={'16'} height={'16'}/></div>
                              <div className={s.menuName}>Удалить сообщение</div>
                          </div>
                        }
                        {
                            !localActions && (getBaseRole(profile?.role) === 'admin' || getBaseRole(profile?.role) === 'junior-admin' || isTechSupport) && (
                                <div className={s.menuRow} onClick={(e) => sendByTelegram(e)}>
                                        <div className={s.menuName}>Продублировать в ТГ-бота</div>
                                </div>
                            )
                        }
                        {!localActions && (getBaseRole(profile?.role) !== 'children' && getBaseRole(profile?.role) !== 'parent') && (
                            <div className={s.menuRow} onClick={(e) => additionalNotice(e)}>
                                <div className={s.menuName} style={{color: 'var(--color-text-soft)'}}>Отправить доп. уведомление о сообщении</div>
                            </div>
                        )}
                    </div>
                </>}


                <div className={s.chatBody}>
                    <div className={s.chatHead} style={{marginLeft: isOwnMessage ? 'auto' : undefined}}>
                        {
                            !isOwnMessage && <div className={s.authorMeta}>
                                <div className={s.authorName}>
                                    {authorDisplayName}
                                </div>
                                <ParentChildrenIcon
                                    member={authorName}
                                    visible={showParentChildren}
                                />
                                {canOpenPrivateChat && (
                                    <OpenPrivateChatButton
                                        className={s.messageBtn}
                                        onClick={openPrivateChat}
                                        iconWidth={18}
                                        iconHeight={18}
                                    />
                                )}
                            </div>
                        }
                        <div className={s.date}>
                            {message?.isEdited && <span title={message.editedAt || undefined}>изменено · </span>}
                            <Moment locale="ru" date={message?.createdAt} format="D MMM YYYY k:mm"  withTitle />
                        </div>
                        {
                            isOwnMessage && <div className={s.authorMeta}>
                                {canOpenPrivateChat && (
                                    <OpenPrivateChatButton
                                        className={s.messageBtn}
                                        onClick={openPrivateChat}
                                        iconWidth={18}
                                        iconHeight={18}
                                    />
                                )}
                                <div className={s.authorName}>
                                    {authorDisplayName}
                                </div>
                                <ParentChildrenIcon
                                    member={authorName}
                                    visible={showParentChildren}
                                />
                            </div>
                        }
                        {(!hideActionsMenu || onForwardMessage) && <div className={s.messageActions} onClick={(event) => event.stopPropagation()}>
                            <button type='button' className={s.dots} onClick={(e) => openMenu(e)}><DotsIcon/></button>
                            <div className={classNames(s.menu, isActive ? s.active : '', isMyMessage ? s.menuLeft : '')} ref={menuRef}
                                 onMouseLeave={() => setIsActive(false)}>
                                {!hideActionsMenu && (
                                    <div className={s.menuRow} onClick={handleClip}>
                                        <div className={s.menuIcon}><ClipIcon width={'16'} height={'16'}/></div>
                                        <div className={s.menuName}>{fixMessageMenuText}</div>
                                    </div>
                                )}
                                {!hideActionsMenu && editMenuItem}
                                {message?.id && onForwardMessage && (
                                    <div className={s.menuRow} onClick={handleForwardMessage}>
                                        <div className={s.menuIcon}><ShareAltOutlined /></div>
                                        <div className={s.menuName}>Переслать сообщение</div>
                                    </div>
                                )}
                                {!hideActionsMenu && canDeleteMessage &&
                                  <div className={s.menuRow} onClick={handleRemoveMessage}>
                                      <div className={s.menuIcon}><DeleteChatIcon width={'16'} height={'16'}/></div>
                                      <div className={s.menuName}>{'\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435'}</div>
                                  </div>
                                }
                                {!hideActionsMenu && !localActions && isMyMessage && (getBaseRole(profile?.role) === 'admin' || getBaseRole(profile?.role) === 'junior-admin' || isTechSupport) && (
                                    <div className={s.menuRow} onClick={(e) => sendByTelegram(e)}>
                                            <div className={s.menuName}>{'\u041f\u0440\u043e\u0434\u0443\u0431\u043b\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0432 \u0422\u0413-\u0431\u043e\u0442\u0430'}</div>
                                    </div>
                                )}
                                {!hideActionsMenu && !localActions && isMyMessage && (getBaseRole(profile?.role) !== 'children' && getBaseRole(profile?.role) !== 'parent') && (
                                    <div className={s.menuRow} onClick={(e) => additionalNotice(e)}>
                                        <div className={s.menuName} style={{color: 'var(--color-text-soft)'}}>{'\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0434\u043e\u043f. \u0443\u0432\u0435\u0434\u043e\u043c\u043b\u0435\u043d\u0438\u0435 \u043e \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0438'}</div>
                                    </div>
                                )}
                            </div>
                        </div>}
                    </div>
                    {message?.forwardedFrom && (
                        <div className={s.forwardedHeader}>
                            <img
                                className={s.forwardedAvatar}
                                src={getAvatar(message.forwardedFrom.avatar)}
                                alt=""
                            />
                            <span>Переслано от {message.forwardedFrom.name || 'пользователя'}</span>
                        </div>
                    )}
                    {parentMessage && (
                        <div className={s.answer}>
                            <div className={s.answerAuthor}>
                                {parentMessageAuthor?.name}
                            </div>
                            <div className={s.answerText}>
                                <MessageTextView
                                    message={getMessagePreview(parentMessage)}
                                    isAuthor={isOwnMessage}
                                />
                            </div>
                        </div>
                    )}
                    {!!message.message && (
                        <MessageView
                            message={message.message}
                            isAuthor={isOwnMessage}
                        />
                    )}
                    <FileView files={message?.files} isAutor={isOwnMessage} />
                    <div 
                        style={{marginLeft: isOwnMessage ? 'auto' : undefined}}
                        className={s.reactionsRow} onClick={(event) => event.stopPropagation()}>
                        {!!reactions.length && (
                            <div className={s.reactionsList}>
                                {reactions.map((reactionItem) => (
                                    <button
                                        key={reactionItem?.reaction}
                                        type='button'
                                        className={classNames(s.reactionBadge, {
                                            [s.reactionBadgeActive]: reactionItem?.reactedByMe,
                                        })}
                                        disabled={isReactionLoading}
                                        onClick={(event) => handleToggleReaction(reactionItem?.reaction, event)}>
                                        <span>
                                            {reactionCodeToUnified[reactionItem?.reaction] ? (
                                                <Emoji
                                                    unified={reactionCodeToUnified[reactionItem?.reaction]}
                                                    emojiStyle={EmojiStyle.APPLE}
                                                    size={16}
                                                />
                                            ) : (
                                                reactionItem?.reaction
                                            )}
                                        </span>
                                        <span>{reactionItem?.count || 0}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                        <div 
                            style={{order: !isOwnMessage ? '-1' : undefined}}
                            className={s.reactionPickerWrapper}>
                            <button
                                type='button'
                                className={s.reactionTrigger}
                                disabled={isReactionLoading}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setIsReactionPickerOpen((prev) => !prev)
                                }}>
                                <span className={s.reactionTriggerText}>+</span>
                            </button>
                            {isReactionPickerOpen && (
                                <div 
                                    style={{
                                        left: !isOwnMessage ? 0 : undefined,
                                        right: isOwnMessage ? 0 : undefined
                                    }}
                                    className={s.reactionPicker}>
                                    {CHAT_REACTIONS.map((reactionItem) => (
                                        <button
                                            key={reactionItem.code}
                                            type='button'
                                            className={s.reactionOption}
                                            disabled={isReactionLoading}
                                            onClick={(event) => handleToggleReaction(reactionItem.code, event)}>
                                            <Emoji
                                                unified={reactionItem.unified}
                                                emojiStyle={EmojiStyle.APPLE}
                                                size={20}
                                            />
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>


                {!hideActionsMenu && !isOwnMessage && <>
                    <div className={s.dots} onClick={(e) => openMenu(e)}><DotsIcon/></div>
                    <div className={classNames(s.menu, isActive ? s.active : '')} ref={menuRef}
                         onMouseLeave={() => setIsActive(false)}>
                        <div className={s.menuRow} onClick={handleClip}>
                            <div className={s.menuIcon}><ClipIcon width={'16'} height={'16'}/></div>
                            <div className={s.menuName}>{fixMessageMenuText}</div>
                        </div>
                        {canDeleteMessage &&
                          <div className={s.menuRow} onClick={handleRemoveMessage}>
                              <div className={s.menuIcon}><DeleteChatIcon width={'16'} height={'16'}/></div>
                              <div className={s.menuName}>Удалить сообщение</div>
                          </div>
                        }
                    </div>
                </>}

                {
                    isOwnMessage && <AvatarWithStatus {...{authorName, isUserOnline}} />
                }
            </div>
        </div>
    )
}
export default ChatMessage;

export const MessageTextView = ({ message = '', isAuthor = false }) => {
    const renderFormattedText = (textPart = '', keyPrefix = 'text') => {
        // "_" не считаем разметкой курсива внутри слова (email, username и т.п.),
        // как это делает CommonMark: снаружи подчёркиваний не должно быть словесного символа.
        return String(textPart)
            .split(/(\*\*[^*]+\*\*|(?<!\w)_[^_]+_(?!\w)|~~[^~]+~~)/g)
            .filter(Boolean)
            .map((chunk, chunkIndex) => {
                if (chunk.startsWith('**') && chunk.endsWith('**') && chunk.length > 4) {
                    return (
                        <strong key={`${keyPrefix}-${chunkIndex}`}>
                            {chunk.slice(2, -2)}
                        </strong>
                    );
                }

                if (chunk.startsWith('_') && chunk.endsWith('_') && chunk.length > 2) {
                    return (
                        <em key={`${keyPrefix}-${chunkIndex}`}>
                            {chunk.slice(1, -1)}
                        </em>
                    );
                }

                if (chunk.startsWith('~~') && chunk.endsWith('~~') && chunk.length > 4) {
                    return (
                        <s key={`${keyPrefix}-${chunkIndex}`}>
                            {chunk.slice(2, -2)}
                        </s>
                    );
                }

                return (
                    <span key={`${keyPrefix}-${chunkIndex}`}>
                        {chunk}
                    </span>
                );
            });
    };

    return <div className={s.text} style={{marginLeft: isAuthor ? 'auto' : undefined}}>
        { 
            String(message).split(mentionMarkupRegex).map((part, index) => {
                    if (index % 2 === 1) {
                        return <span key={index} style={{ color: 'var(--color-status-info-text)' }}>
                            @{part}
                        </span>;
                    }
                    return <span key={index}>
                        {renderFormattedText(part, `message-${index}`)}
                    </span>;
                }
            )
        }
    </div>
};

export const MessageView = ({message, isAuthor = false, className=''}) => {
    // message приходит не только строкой: колонка chat_messages.message — JSON,
    // поэтому «123» доезжает числом, а системные сообщения — объектом {type, text}.
    const normalizedMessage = getMessageText(message);
    const tiptapMessage = getTiptapMessage(message);

    if (tiptapMessage) {
        if (containsHtmlTags(normalizedMessage)) {
            return (
                <div className={classNames(s.messageDz, s.text, {[className]: !!className})}>
                    <div dangerouslySetInnerHTML={{ __html: tiptapMessage.before }} />
                    <JsonPars json={normalizeTiptapContent(tiptapMessage.content)} />
                    <div dangerouslySetInnerHTML={{ __html: tiptapMessage.after }} />
                </div>
            )
        }

        return (
            <div className={classNames(s.messageDz, s.text, {[className]: !!className})}>
                {tiptapMessage.before && <MessageTextView message={tiptapMessage.before} isAuthor={isAuthor} />}
                <JsonPars json={normalizeTiptapContent(tiptapMessage.content)} />
                {tiptapMessage.after && <MessageTextView message={tiptapMessage.after} isAuthor={isAuthor} />}
            </div>
        )
    }

    if((normalizedMessage && containsHtmlTags(normalizedMessage))){
        return (
            <div
                style = {{marginLeft: isAuthor ? 'auto' : undefined}}
                dangerouslySetInnerHTML={{ __html: normalizedMessage }}
                className={classNames(s.messageDz, s.text, {[className]: !!className})}
            />
        )
    }

    return (
        <MessageTextView 
            isAuthor={isAuthor}
            message={normalizedMessage}
        />
    )
} 

const getTiptapMessage = (message) => {
    if (message && typeof message === 'object' && message?.type === 'doc' && Array.isArray(message?.content)) {
        return { before: '', content: message, after: '' };
    }

    const source = String(message ?? '')
        .replace(/&quot;|&#34;|&#x22;/gi, '"');
    const trimmedSource = source.trim();

    try {
        const parsedMessage = JSON.parse(trimmedSource);

        if (parsedMessage?.type === 'doc' && Array.isArray(parsedMessage?.content)) {
            return { before: '', content: parsedMessage, after: '' };
        }
    } catch (error) {
        // Обычный текст сообщения не является JSON.
    }

    const start = source.search(/\{\s*"type"\s*:\s*"doc"/);

    if (start === -1) return null;

    let depth = 0;
    let isString = false;
    let isEscaped = false;

    for (let index = start; index < source.length; index += 1) {
        const symbol = source[index];

        if (isEscaped) {
            isEscaped = false;
            continue;
        }
        if (symbol === '\\') {
            isEscaped = true;
            continue;
        }
        if (symbol === '"') {
            isString = !isString;
            continue;
        }
        if (isString) continue;
        if (symbol === '{') depth += 1;
        if (symbol === '}') depth -= 1;

        if (depth === 0) {
            try {
                const content = JSON.parse(source.slice(start, index + 1));

                if (content?.type === 'doc' && Array.isArray(content?.content)) {
                    return {
                        before: source.slice(0, start),
                        content,
                        after: source.slice(index + 1),
                    };
                }
            } catch (error) {
                return null;
            }
        }
    }

    return null;
}

const AvatarWithStatus = ({authorName, isUserOnline}) => {
    return (
        <div className={s.photo}>
            <UserImage path={authorName?.avatar}/>
            {isUserOnline?.length === 1 && <div className={s.isOnline}></div>}
        </div>
    )
}
